import {qspost} from '@/plugins/axios'

/*
 * 项目列表
 * @constructor jack
 * */
export const xiangMuList = (searchName,jingLiName,status, page, pageSize) => qspost('/Index/Xiangmu/xiangMuList', {
  searchName,jingLiName,status, page, pageSize
})

/*
 * 获取社区的列表
 * @constructor jack
 * */
export const jingLiList = (isAll,xiangMuId) => qspost('/Index/Xiangmu/xiangMuJingLiList', {isAll,xiangMuId})

/*
 * 添加/修改 项目
 * @constructor jack
 * */
export const xiangMuAdd = (name, xiangmujingliId, shengId, shengName, shiId, shiName, quId, quName, address, beizhu, id) => qspost('/Index/Xiangmu/xiangMuAdd', {
  name,
  xiangmujingliId,
  shengId,
  shengName,
  shiId,
  shiName,
  quId,
  quName,
  address,
  beizhu,
  id
})

/*
 * 项目详情
 * @constructor jack
 * */
export const xiangMuShow = (id) => qspost('/Index/Xiangmu/xiangMuShow', {id})

/*
 * 项目删除
 * @constructor jack
 * */
export const xiangMudel = (id) => qspost('/Index/Xiangmu/xiangMudel', {id})

/*
 * 项目状态修改
 * @constructor jack
 * */
export const xiangMuUpdateStatus = (id,status) => qspost('/Index/Xiangmu/xiangMuUpdateStatus', {id,status})

